// This is a mixin which provides an object with the ability to set and manage a state on the html class values using BEM style modifiers.
// Pass in obj to extend the obj's prototype with the methods.

export function MixinHtmlClassState(obj) {
  mixinMethods(obj);
}

function mixinMethods(obj) {
  Object.assign(obj.__proto__, {

    hasRequiredHtmlClassStateProperties() {
      if (typeof this.element === 'undefined' || this.element === null) { return false }
      if (typeof this.baseHtmlClass === 'undefined' || this.baseHtmlClass === null) { return false }
      return true;
    },

    addHtmlClassState(state) {
      if (state === null) { return }
      if (!this.hasRequiredHtmlClassStateProperties()) return;
      this.element.classList.add(this.htmlClassNameForState(state));
    },

    removeHtmlClassState(state) {
      if (state === null) { return }
      if (!this.hasRequiredHtmlClassStateProperties()) return;
      this.element.classList.remove(this.htmlClassNameForState(state));
    },

    toggleHtmlClassState(state) {
      if (state === null) { return }
      if (!this.hasRequiredHtmlClassStateProperties()) return;
      this.element.classList.toggle(this.htmlClassNameForState(state));
    },

    conditionallySetHtmlClassState(condition, state) {
      (!!condition) ? this.addHtmlClassState(state) : this.removeHtmlClassState(state);
    },

    swapHtmlClassStates(condition, true_state, false_state) {
      if (!!condition) {
        this.addHtmlClassState(true_state);
        this.removeHtmlClassState(false_state)
      } else {
        this.addHtmlClassState(false_state);
        this.removeHtmlClassState(true_state);
      }
    },

    hasHtmlClassState(state) {
      if (state === null) { return false }
      return this.element.classList.contains(this.htmlClassNameForState(state))
    },

    /**
     * Looks at the HTML classes applied to the element and extracts the modifiers on the base HTML class, returning them as an array of strings.
     * eg. for a class attribute of "foo foo--bar foo--baz" it will return `['bar', 'baz']`.
     * @returns {string[]}
     */
    getStatesFromHtmlClasses() {
      const prefix = `${this.baseHtmlClass}--`;
      let htmlClasses = Array.from(this.element.classList);
      let stateClasses = htmlClasses.filter((htmlClass)=>{
        return htmlClass.startsWith(prefix)
      });
      return stateClasses.map((stateClass)=>{
        return stateClass.substring(prefix.length);
      });
    },

    htmlClassNameForState(state) {
      if (state === null) { return }
      return `${this.baseHtmlClass}--${state}`
    }

  });
}
